<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title">Substituição de Equipe</span>
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable mdl-textfield--floating-label mdl-textfield--align-right">
      </div>        
      </div>
    </header>
    <div class="mdl-layout__drawer">
      <span class="mdl-layout-title">Ignis Equipes</span>
      <nav class="mdl-navigation">
        <router-link class="mdl-navigation__link" to="/" @click.native="hideMenu"><i class="material-icons">calendar_today</i> Agenda</router-link>
        <router-link class="mdl-navigation__link" to="/changes" @click.native="hideMenu"><i class="material-icons">swap_horiz</i> Substituição de Equipe</router-link>        
        <router-link class="mdl-navigation__link" to="/inbox" @click.native="hideMenu" v-if="demo"><i class="material-icons">mail_outline</i> Comunicados</router-link>
        <router-link class="mdl-navigation__link" to="/outbox" @click.native="hideMenu" v-if="demo"><i class="material-icons">message</i> Solicitações</router-link>
        <router-link class="mdl-navigation__link" to="/surveys" @click.native="hideMenu" v-if="demo"><i class="material-icons">live_help</i> Questionários</router-link>
      </nav>
    </div>
    <main class="mdl-layout__content">
      <div class="page-content">
        <div v-for="change in changes" class="calendar-card" :key="change.id" v-on:click="openChange(change)" v-bind:class="changeClass(change)">
          <i class="pull-right material-icons" v-html="changeIcon(change)"></i>
          <div class="calendar-box">
            <div class="calendar-day">{{formatDay(change.date)}}</div>
            <div class="calendar-day-of-week">{{formatDayOfWeek(change.date)}}</div>
          </div>
          <strong>{{ change.missing_name }} ({{ change.missing_real_state }}) </strong> substituído por <strong>{{ change.substitute_name }} ({{ change.substitute_real_state }})</strong><br>
          {{ change.reason }}
        </div>
<button id="btn-add" class="mdl-button mdl-js-button mdl-button--fab mdl-button--colored">
  <i class="material-icons">add</i>
</button>

      </div>
    </main>
  </div>
</template>
<script>

  import Vue from 'vue'
  import firebase from 'firebase/app'
  import db from './firebaseInit'
  import localDb from './localDb'
  import * as moment from 'moment'
  import 'material-design-lite'

  var instancePath = 'instances/' + process.env.FSM_ENV
  var currentUser = localStorage.getItem('currentUser')
  var instanceRef = db.doc(instancePath)
  var requestsRef = db.collection(instancePath + '/requests')

  var current_id
  var current_change
  export default {
    data: function() {
      return {
        demo: process.env.FSM_DEMO,
        today: this.$route.params.d || moment().format('YYYY-MM-DD'),
        changes: [],
        instancePath: instancePath
      }  
    },
    mounted() {
      console.log("mounted")
      if (localStorage.getItem('currentUser') == null) {
        this.$router.push("/")
      }
      this.initListener()
      componentHandler.upgradeAllRegistered();
    },
    updated() {
      console.log("updated")
    },
    methods: {
      initListener: function() {
        let data = this
        let instanceRef = db.doc(instancePath)
        instanceRef.collection('changes').onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type == 'removed') {
              var record_index = data.changes.findIndex(function(record) { return record.id == change.doc.data().id })
              if (record_index != -1) {
                data.changes.splice(record_index, 1)
              }
            } else {
              data.changes.splice(0, 0, change.doc.data())
            }
          })
        })
      },
      formatDate: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY')
      },
      formatDay: function(date) {
        return moment(date).format('DD/MM')
      },
      formatDayOfWeek: function(date) {
        return moment(date).format('ddd')
      },
      send: function(id) {
        var task = this.tasks[id]
        if (task.status == 'open') {
          task.status = 'started';
          instanceRef.collection('changes').doc(id).update({
            status: 'started'
          })
        } else if (task.status == 'started') {
          current_id = id
          current_task = task
          this.$router.push("/changes/" + id)
        }
      },
      openChange: function(change) {
        if (change.status == 'open')
          this.$router.push("/changes/" + change.id)
      },
      changeUrl: function(change) {
        return '/changes/' + change.id
      },
      changeActions: function(change) {
        //if (task.status == 'open')
          //return ['play_arrow'];
        //if (task.status == 'started')
          //return ['stop'];
        return null;
      },
      changeIcon: function(change) {
        if (change.status == 'closed') {
          if (change.received_date)
            return 'done_all'
          else
            return 'done'  
        }
        return null;
      },
      changeClass: function(change) {
        if (change.status == 'open')
          return 'open';
        if (change.status == 'started')
          return 'started';
        if (change.status == 'closed')
          return 'completed';
        return 'empty';
      }
    }
  }
</script>
<style>
  .calendar-box {
    text-align: center;
    height: 40px;
    float: left;
    margin-right: 12px;
  }
  .calendar-day {
    font-size: 18px;
  }
  .calendar-day-of-week {
    font-size: 12;
  }
  .calendar-card:before,
  .calendar-card:after {
    content: " ";
    display: table;
  }
  .calendar-card:after {
    clear: both;
  }
  .calendar-card {
    padding: 10px;
  }
  .pull-left {
    float: left;
  }
  .pull-right {
    float: right;
  }
  .center {
    text-align: center;
  }
  h5 {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  #btn-add {
    position: fixed;
    right: 50px;
    bottom: 50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ChangesView.vue